exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#collection-link-file-dropzone[data-v-1a9c308f]{min-height:138px}#collection-link-file-add-files[data-v-1a9c308f]{padding-top:55px}.dz-uploaded-file[data-v-1a9c308f]{cursor:default}#collection-link-file-add-more-files[data-v-1a9c308f]{position:absolute;left:15px;bottom:16px}.progress-display[data-v-1a9c308f]{position:absolute;left:15px;bottom:10px;width:calc(100% - 100px)}", ""]);

// exports
